<template>
          <tr :class="{'has-subitems-x': item.children?.length, archived: item.archived, subitem: indent}" :data-indent="''+(indent || 0)">
            <td v-for="(column, ci) in cColumns" :class="column.classes" :style="column.styles" :width="column.width">
              <component v-if="column.contentComponent" :is="column.contentComponent" :column="column" :item="item" :dataConfig="dataConfig" v-model:childrenShown="childrenShown" :value="colVal(item, column.name)" />
              <div v-else-if="column.name=='checkbox'" class="check">
                <label>
                  <input type="checkbox" v-model="cRows2" :value="item.uuid" />
                  <span><i class="fa-solid fa-check"></i></span>
                </label>
                <template v-if="!noChildren && item.children?.length">
                  <a class="children" href="" @click.prevent="childrenShown=!childrenShown">
                    <i v-if="!childrenShown" class="fa-solid fa-chevron-down"></i>
                    <i v-else class="fa-solid fa-chevron-up"></i>
                  </a>
                </template>
              </div>
              <div v-else-if="colVal(item, column.name)?.component">
                <component :is="colVal(item, column.name)?.component" :item="item" :column="column"  :dataConfig="dataConfig" v-model:childrenShown="childrenShown" :value="colVal(item, column.name)" />
              </div>
              <template v-else>
                <component :is="item.link?'a':'span'" target="_blank" :href="item.link">
                  <div v-if="colVal(item, column.name)===null">
                    (not set)
                  </div>
                  <div v-else-if="typeof(colVal(item, column.name))!='object'">
                    {{ colVal(item, column.name) }}
                  </div>
                  <div v-else>
                    custom content here <!-- TODO -->
                  </div>
                </component>
              </template>
              <template v-if="column.childToggle">
                <div class="child-actions">
                  <template v-if="item.linkParamsChild">
                    <router-link :to="item.linkParamsChild">
                      <i class="fa-solid fa-plus"></i>
                    </router-link>
                  </template>
                </div>
              </template>
            </td>
          </tr>
          <ScDataTableItem v-if="childrenShown" v-for="itemChild in item.children" :key="'item'+itemChild.uuid" :item="itemChild" :cColumns="cColumns" :checkAll="checkAll" v-model:cRows="cRows2" :dataConfig="dataConfig" :indent="(indent || 0)+1" />
</template>

<script>
export default {
  props: ["indent", "item", "cColumns", "cRows", "dataConfig", "checkAll", "noChildren"],
  data: ()=>({
    childrenShown: false,
  }),
  computed: {
    cRows2: {
      get() {
        return this.cRows;
      },
      set(value) {
        this.$emit("update:cRows", value);
      },
    },
  },
  methods: {
    colVal(item, column) {
      var columnParts=(column || "").split(".").filter(item=>item);
      var value=item;
      while(columnParts.length) {
        var part=columnParts.shift();
        value=value?.[part];
      }
      return value;
    }
  }
}
</script>
